import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5, 2),
    backgroundColor: theme.palette.background.default,
  },
  counter: {
    marginRight: 'auto',
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
}))

export default useStyles
